import { Text, Button } from '@clockout-dev/design-elements';
import { SEGMENTATION_MODE } from '../../../configuration.constants';
import styles from '../styles/userEligibilityForm.module.scss';

function ModeActionPanel({
    description,
    mode
}) {
    const isDisabled = mode === SEGMENTATION_MODE.DISABLED;
    const buttonText = isDisabled ? 'Active disabled mode' : 'Active open model';

    return (
        <>
            <div className={styles.notice}>
                <Text as="span" size="s" className={styles.noticeText}>
                    {description}
                </Text>
            </div>

            <div className={styles.actionPanelButtons}>
                <Button
                    type="submit"
                    className={isDisabled ? styles.buttonDisabled : styles.buttonOpen}
                >
                    {buttonText}
                </Button>
            </div>
        </>
    );
}

export default ModeActionPanel;
